import { GoogleMap, MarkerF, useJsApiLoader } from "@react-google-maps/api";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import edit from "../../assets/images/icons/edit-icon_b.svg";

interface SelectLocationOnMapProps {
  onLocationSelect?: (lat: number, lng: number) => void;
  defaultLocation?: { lat: number; lng: number } | null;
  customMarker?: string;
  className?: string;
  ViewOnly?: boolean;
  withEditBtn?: boolean;
}

const SelectLocationOnMap: React.FC<SelectLocationOnMapProps> = ({
  onLocationSelect,
  defaultLocation,
  customMarker,
  ViewOnly = false,
  withEditBtn = false,
  className,
}) => {
  const fallbackCenter = { lat: 33.5138, lng: 36.2765 };

  const { t } = useTranslation();
  const [selectedLocation, setSelectedLocation] = useState<{
    lat: number;
    lng: number;
  } | null>(defaultLocation || null);

  const [isEditing, setIsEditing] = useState<boolean>(ViewOnly);
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyBJoyRoY489sYJoEYbfbyJysIdAJQQLVNw",
  });
  useEffect(() => {
    setSelectedLocation(defaultLocation || null);
  }, [defaultLocation]);

  const handleMapClick = (event: google.maps.MapMouseEvent) => {
    if (event.latLng && isEditing) {
      const lat = event.latLng.lat();
      const lng = event.latLng.lng();
      setSelectedLocation({ lat, lng });
      onLocationSelect && onLocationSelect(lat, lng);
    }
  };

  useEffect(() => {
    if (ViewOnly) {
      setIsEditing(false);
    }
  }, [ViewOnly]);

  if (!isLoaded) {
    return <div className="h-96 w-full rounded-lg bg-gray-100" />;
  }
  return (
    <div
      className={`relative h-full min-w-80 overflow-hidden rounded-lg ${className}`}
    >
       
        
      {!isEditing && withEditBtn && (
        <button
          onClick={() => setIsEditing(true)}
          className="hover:bg-primary-bg absolute start-4 top-4 z-10 flex items-center gap-1 rounded-lg bg-white p-2 text-sm text-primary"
        >
          <img src={edit} alt="edit" />
          <span>{t("edit")}</span>
        </button>
      )}

      <GoogleMap
        mapContainerStyle={{ height: "100%", width: "100%" }}
        zoom={18}
        center={selectedLocation || fallbackCenter}
        onClick={handleMapClick}
      >
        {selectedLocation && (
          <MarkerF
            position={selectedLocation}
            icon={
              customMarker
                ? {
                    url: customMarker,
                    scaledSize: new google.maps.Size(100, 100),
                    anchor: new google.maps.Point(50, 50),
                  }
                : undefined
            }
          />
        )}
      </GoogleMap>

      {!isEditing && withEditBtn && (
        <div className="absolute inset-0 z-0 bg-black/20" />
      )}
    </div>
  );
};

export default SelectLocationOnMap;
